import { render, staticRenderFns } from "./FilterSelection.vue?vue&type=template&id=4638ae57&scoped=true"
import script from "./FilterSelection.vue?vue&type=script&lang=js"
export * from "./FilterSelection.vue?vue&type=script&lang=js"
import style0 from "./FilterSelection.vue?vue&type=style&index=0&id=4638ae57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638ae57",
  null
  
)

export default component.exports